<template>
  <div ref="reviewsElement" class="reviews-wrapper">
    <div class="model-reviews" data-copy="for-copied">
      <h2 class="title heading-m" :class="{ 'title--base': isBaseTab }">
        Отзывы
        <sup class="reviews__count body-s-regular">
          {{ totalReviews ? totalReviews : '' }}</sup
        >
      </h2>
      <div v-if="isOtzyvyList && reviewsSelectedCount">
        <UiReviewsTabs :count="reviewsSelectedCount" @set-tab="setReviewsTab" />
      </div>
      <div
        :class="[
          'btns',
          'review__sliders-wrapper',
          { 'review__sliders-wrapper--base': isBaseTab },
          {
            'review__sliders-wrapper--otzyvy': !isBaseTab,
          },
          {
            'review__sliders-wrapper--otzyvy-padding': isPadding,
          },
          {
            'review__sliders-wrapper_no-images':
              allPhotoInReviews?.length === 0 && otzyvy && isOtzyvyList,
          },
          {
            'hide-mobile': isMd && otzyvy && !isOtzyvyList,
          },
        ]"
      >
        <div
          v-if="allPhotoInReviews?.length > 0"
          class="review__sliders"
          :class="{ 'review__sliders--base': isBaseTab }"
        >
          <p class="review__slider-title body-l-semibold">
            Фотографии покупателей ({{ allPhotoInReviews?.length }})
          </p>
          <ui-multiple-swiper
            :free-mode="isMobile"
            class="review-slider user-pictures"
            :white_buttons="false"
            :space-between="spaceBetween"
          >
            <ui-multiple-swiper-slide
              v-for="(slide, key) in allPhotoInReviews"
              :key="`${slide.id}_${key}`"
              class="review-slider-items"
            >
              <div
                class="review-slider-item"
                @click="
                  () => {
                    openSliderModal(allPhotoInReviews, key);
                  }
                "
              >
                <ui-responsive-image
                  :src="slide"
                  alt="img"
                  :lazy="true"
                  :mobile-sizes="{ width: 80, height: 80 }"
                  :desktop-sizes="{ width: 80, height: 80 }"
                />
              </div>
            </ui-multiple-swiper-slide>
          </ui-multiple-swiper>
        </div>
        <div
          v-if="!isBaseTab && isOtzyvyList"
          class="create-reviews create-reviews--mobile"
          :class="{
            'create-reviews--base': isBaseTab,
            'create-reviews--otzyvy': otzyvy,
            notempty: totalReviews !== 0,
          }"
        >
          <ui-ui-button
            size="medium"
            font-class="body-l-regular"
            :resize="true"
            @click="createNewReview"
            >Оставить отзыв
          </ui-ui-button>
          <p class="body-l-regular-long">
            Поделитесь опытом использования товара, расскажите о его
            достоинствах и недостатках в своем отзыве
          </p>
        </div>
      </div>
      <div
        v-if="isOtzyvyList"
        :class="[
          'review-wrap',
          {
            'review-wrap--otzyvy': !isBaseTab,
          },
        ]"
      >
        <template v-if="isLoading">
          <div class="review-loader-wrap">
            <UiPButtonButtonLoader type="invert" />
          </div>
        </template>
        <template v-else>
          <template
            v-for="(review, index) of otzyvy.list"
            :key="`review_${review.id}_${index}`"
          >
            <article
              v-if="index < articleInView"
              :id="`review-card-${index}`"
              class="review"
              :class="{
                'review--base': isBaseTab,
                'review-single': totalReviews === 1,
                'review-double': totalReviews < 3,
              }"
            >
              <header class="review-info">
                <img
                  src="/static/images/icon/ava.svg"
                  :alt="review.author"
                  class="ava"
                />
                <div class="text">
                  <div class="author body-l-semibold">
                    {{ review.author }}
                    <span v-if="review.date" class="date body-m-regular">
                      {{ dateWithMonth(review.date) }}
                    </span>
                  </div>
                  <div class="rating-and-date text-body-m-book">
                    <score :value="review.score" open />
                  </div>
                </div>
              </header>
              <div v-if="review.model_id" class="include-linked-slug">
                <span class="body-l-regular-long">Отзыв о модели: </span>
                <a
                  :href="`/${review.model_slug}/`"
                  class="p_link body-l-regular-long"
                >
                  {{ review.model_name }}
                </a>
              </div>
              <div ref="reviewText" class="reviewText">
                <section v-if="review.pros" class="pros">
                  <span class="header body-l-semibold">Достоинства: </span>
                  <span class="text body-l-regular-long">{{
                    review.pros
                  }}</span>
                </section>
                <section v-if="review.cons" class="cons">
                  <span class="header body-l-semibold">Недостатки: </span>
                  <span class="text body-l-regular-long">{{
                    review.cons
                  }}</span>
                </section>
                <section v-if="review.review" class="comm">
                  <span class="header body-l-semibold">Комментарий: </span>
                  <span class="text body-l-regular-long">{{
                    review.review
                  }}</span>
                </section>
              </div>
              <div
                v-if="isBaseTab && getMore(index)"
                class="more-reviews body-l-regular-long"
                @click="toRoute(index)"
              >
                <span>ещё</span>
              </div>
              <div
                v-if="review.images?.length"
                class="review__sliders in-review"
              >
                <ui-multiple-swiper
                  :free-mode="isMobile"
                  :space-between="spaceBetween"
                  class="review-slider user-pictures"
                  :class="{
                    'review-slider--base': isBaseTab,
                    'review-slider--otzyvy': otzyvy,
                  }"
                >
                  <ui-multiple-swiper-slide
                    v-for="(slide, key) in review.images"
                    :key="`${slide.id}_${key}`"
                    class="review-slider-items"
                  >
                    <div
                      class="review-slider-item in-review"
                      @click="
                        () => {
                          openSliderModal(getAllUrlImg(review.images), key);
                        }
                      "
                    >
                      <ui-responsive-image
                        :src="getUrlImg(slide)"
                        alt="img"
                        :lazy="true"
                        :mobile-sizes="{ width: 80, height: 80 }"
                        :desktop-sizes="{ width: 80, height: 80 }"
                      />
                    </div>
                  </ui-multiple-swiper-slide>
                </ui-multiple-swiper>
              </div>
              <section class="emotion" :class="{ 'emotion--base': isBaseTab }">
                <div
                  v-if="'likes' in review"
                  class="like body-l-medium"
                  :class="{
                    active: getIsActive(review.id) === 'like',
                    disabled: getIsActive(review.id),
                  }"
                  @click="sendEmotion(review.id, true)"
                >
                  {{ review.likes }}
                </div>
                <div
                  v-if="'dislikes' in review"
                  class="dislike body-l-medium"
                  :class="{
                    active: getIsActive(review.id) === 'dislike',
                    disabled: getIsActive(review.id),
                  }"
                  @click="sendEmotion(review.id, false)"
                >
                  {{ review.dislikes }}
                </div>
              </section>
            </article>
          </template>
        </template>
        <div
          v-if="isBaseTab && totalReviews > 6 && !isLoading"
          class="more-reviews-section"
          @click="$emit('to-route', 'otzyvy')"
        >
          <div>Все отзывы</div>
          <img :src="`/static/images/arrow-button-right.svg`" alt="arrow" />
        </div>
        <div
          v-if="isBaseTab && totalReviews === 1"
          class="prompt-reviews-section"
          @click="$emit('to-route', 'otzyvy')"
        >
          <div>Скоро тут будет чей-то отзыв</div>
        </div>
      </div>
      <div
        v-if="pageCount > 1 || isBaseTab"
        :class="[
          'pagination-wrap',
          {
            'is-paginator': pageCount > 1 && !isBaseTab,
            'pagination-wrap-no-reviews': !isOtzyvyList,
          },
        ]"
      >
        <template v-if="otzyvy && isOtzyvyList">
          <slot name="pagination" />
          <template v-if="isBaseTab">
            <ui-ui-button class="new-review" @click="createNewReview">
              Оставить отзыв
            </ui-ui-button>
            <ui-ui-button
              type="neutral"
              class="all-reviews"
              @click="$emit('to-route', 'otzyvy')"
            >
              Все отзывы
            </ui-ui-button>
          </template>
        </template>
        <ui-pagination
          v-if="!isBaseTab"
          class="pagination"
          :page-count="pageCount"
          :active="activePage"
          :wide="widePagination"
          @on-page-change="setActive"
        />
      </div>
      <template v-if="!isOtzyvyList">
        <div
          class="no-reviews-wrapper review__sliders-wrapper"
          :class="{ 'no-reviews-wrapper--base': isBaseTab }"
        >
          <div class="no-reviews body-l-regular-long">
            К сожалению, пока нет отзывов к данному товару. Будет здорово, если
            вы напишете свои впечатления о товаре. Это поможет другим
            покупателям.
          </div>
          <ui-ui-button
            class="create-reviews-button-mobile"
            :resize="true"
            size="medium"
            @click="createNewReview"
            >Оставить отзыв
          </ui-ui-button>
        </div>
      </template>
      <client-only>
        <ModalsFeedbackModal
          v-if="showFeedbackModal"
          :model-id="model.id"
          @close="closeFeedbackModal"
        />
      </client-only>
      <client-only>
        <ModalsConfirmModal
          v-if="showConfirmModal"
          title="Спасибо за отзыв!"
          description="Ваш отзыв отправлен на проверку и будет опубликован на сайте сразу после ее завершения"
          apply-text="Хорошо"
          :on-apply="() => $emit('close')"
          @close="showConfirmModal = false"
        />
        <PageModelModelReviewsSliderModal
          v-if="showSliderModal"
          :photos="slideArr"
          :index-view-image="activeSlide"
          @close="closeSliderModal"
        />
      </client-only>
    </div>
    <div
      class="create-reviews create-reviews--not-mobile"
      :class="{
        'create-reviews--base': isBaseTab,
        'create-reviews--otzyvy': !isBaseTab,
        notempty: totalReviews !== 0,
        empty: totalReviews === 0,
      }"
    >
      <ui-ui-button
        :resize="true"
        font-class="body-l-regular"
        @click="createNewReview"
        >Оставить отзыв
      </ui-ui-button>
      <p class="body-l-regular-long">
        Поделитесь опытом использования товара, расскажите о его достоинствах и
        недостатках в своем отзыве
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ResponseModel, ResponseModelReviews } from '~/interfaces/api';
import { API } from '~/api/api';
import { useGlobalStore } from '~/stores/global';
import { modelsReviews } from '~/api/pageModel';
import { useMediaQueryStore } from '~/stores/mediaQuery';

const props = defineProps({
  perPage: {
    type: Number,
    default: 20,
  },
  model: {
    type: Object as () => ResponseModel,
    required: true,
  },
  pageData: {
    type: Object as () => ResponseModel,
    required: true,
  },
  pictures: Object as any,
  widePagination: Boolean,
  whenVisible: Boolean,
  changedPage: Boolean,
  isBaseTab: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['change-data', 'to-route', 'close']);
const globalStore = useGlobalStore();

const otzyvy = ref<ResponseModelReviews>({
  list: [],
  per_page: 0,
  total: 0,
  model_id: 0,
  model_name: '',
  model_slug: '',
});
const showFeedbackModal = ref(false);
const showConfirmModal = ref(false);
const showSliderModal = ref(false);
const isLoading = ref(false);
const activeSlide = ref(0);
const returnScrollTop = ref(0);
const slideArr = ref<string[]>([]);
const activePage = ref<number>(otzyvy.value?.page || 1);
const includeLinked = ref(1);
const emotionData = ref<{ [key: string]: string }>({});
const totalReviews = ref<Number>(props.model.review_count);
const reviewsElement = ref<HTMLElement>();
const reviewText = ref<HTMLElement[]>();
const isBot = computed(() => globalStore.isBot);
const isPadding = computed(() => {
  return otzyvy.value?.list?.length < 1 || isLoading.value;
});
const pageCount = computed(() => {
  if (!otzyvy.value?.list?.length || !otzyvy.value?.total) return 1;
  return Math.ceil(otzyvy.value.total / otzyvy.value.per_page);
});
const h1text = computed(() => props.seoData?.page?.h1 || '');
const mediaStore = useMediaQueryStore();
const isMobile = computed(() => mediaStore.isMobile);
const isMd = computed(() => mediaStore.isMd);
const isLessLg = computed(
  () => mediaStore.isEs || mediaStore.isSm || mediaStore.isMd
);
const spaceBetween = computed(() =>
  mediaStore.isEs || mediaStore.isSm || mediaStore.isMd ? 4 : 12
);
const articleInView = computed(() => {
  if (!props.isBaseTab) return props.perPage;
  return mediaStore.isEs || mediaStore.isSm || mediaStore.isMd ? 6 : 3;
});
const allPhotoInReviews = computed(() => {
  const url = import.meta.env.VITE_PRICE_HOST || 'price.hnh-dev.ru';
  if (props?.pictures && props?.pictures?.images?.length > 0) {
    return props?.pictures?.images.map((urlLink: string) => {
      return `https://${url}/-${urlLink}`;
    });
  } else return [];
});
const { $ymAnyEvent } = useNuxtApp();
const isOtzyvyList = computed(
  () => otzyvy.value && !!otzyvy.value?.list?.length
);

const reviewsSelectedCount = computed(() => otzyvy.value?.selected_total || 0);

const toRoute = (index: string | number) => {
  if (isLessLg.value) {
    globalStore.setScrollToQuestion('review-card-' + index.toString());
    emit('to-route', 'otzyvy');
  }
};

const dateWithMonth = (date: string) =>
  new Date(date)
    .toLocaleDateString('ru', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })
    .replace(' г.', '');

const getUrlImg = (urlImg: string) => {
  if (!urlImg) return;
  return `https://${
    import.meta.env.VITE_PRICE_HOST || 'price.hnh-dev.ru'
  }/-${urlImg}`;
};

const getAllUrlImg = (urlImg: string[]) => {
  return urlImg.map((urlImg: string) => {
    return getUrlImg(urlImg);
  });
};
let photosLoaded = false;

const getModelReviews = async (modelId: number) => {
  const reviewsData = await modelsReviews(modelId, {
    per_page: props.perPage,
    page: activePage.value,
    external: false,
    include_linked: includeLinked.value === 1,
    region_id: globalStore.region.id,
    // антикеш
    tbp: `${modelId}${+new Date()}rew`,
  });
  if (reviewsData) {
    otzyvy.value = reviewsData;
    emit('change-data', {
      key: 'reviewsData',
      data: reviewsData,
    });
  } else {
    emit('change-data', {
      key: 'reviewsData',
      data: { list: [], per_page: 0, total: 0 },
    });
    activePage.value = 1;
  }
  if (
    !props.pictures?.images?.length &&
    !photosLoaded &&
    reviewsData?.list?.length
  ) {
    photoAllReviews(modelId);
    photosLoaded = true;
  }
};

const photoAllReviews = async (modelId: number) => {
  API.get(`/models/${modelId}/reviews/images`, {
    params: {
      per_page: 20,
      page: 1,
      region_id: globalStore.region.id,
    },
  })
    .then((res) =>
      emit('change-data', {
        key: 'pictures',
        data: res.data,
      })
    )
    .catch(() => ({ list: [], per_page: 0, total: 0 }));
};

const setActive = (active: number) => {
  activePage.value = active;
  if (window && reviewsElement.value) {
    const y = reviewsElement.value.getBoundingClientRect().top - 90;
    window.scrollTo({
      top: window.scrollY + y,
      left: 0,
      behavior: 'smooth',
    });
  }
  getModelReviews(props.model.id);
};

const createNewReview = (): void => {
  $ymAnyEvent('reachGoal', 'click_otzyv');
  showFeedbackModal.value = true;
};

const sendEmotion = (reviewId: number, isLike: boolean) => {
  if (String(reviewId) in emotionData.value) return;
  API.post(`/models/${reviewId}/reviews/${isLike ? 'like' : 'dislike'}`)
    .then(() => {
      getModelReviews(props.model.id);
      if (!import.meta.env.SSR && window) {
        const emotion = window.localStorage.getItem('emotion') || '';
        const emotionObg = emotion ? JSON.parse(emotion) : {};
        const setData = {
          [String(reviewId)]: isLike ? 'like' : 'dislike',
          ...emotionObg,
        };
        window.localStorage.setItem('emotion', JSON.stringify(setData));
        emotionData.value = setData;
      }
    })
    .catch((e: ErrorEvent) => {
      console.error(e);
    });
};

const getIsActive = (id: number) => {
  const stringId = String(id);
  return stringId in emotionData.value ? emotionData.value[stringId] : '';
};

const openSliderModal = (slidersImg: string[], key: number) => {
  const html = document.querySelector('html');
  if (html) returnScrollTop.value = html.scrollTop;
  activeSlide.value = key;

  showSliderModal.value = true;
  slideArr.value = slidersImg;
};

const closeSliderModal = () => {
  activeSlide.value = 0;
  showSliderModal.value = false;
  slideArr.value = [];
  if (window && returnScrollTop.value) {
    setTimeout(() => {
      window.scrollTo({
        top: returnScrollTop.value,
      });
      returnScrollTop.value = 0;
    });
  }
};

const closeFeedbackModal = (e: string) => {
  showFeedbackModal.value = false;
  if (e === 'success') {
    showConfirmModal.value = true;
  }
};

const getMore = (index: number) => {
  if (!import.meta.env.SSR && reviewText.value) {
    const current = reviewText?.value[index];
    if (current) {
      return current.scrollHeight > 280;
    }
  }
  return false;
};

const initModelReviews = () => {
  if (
    props.whenVisible &&
    reviewsElement.value &&
    otzyvy.value?.per_page !== props.perPage
  ) {
    activePage.value = 1;
    getModelReviews(props.model.id);
  }
};

if (isBot) {
  otzyvy.value = props.pageData.reviewsData;
}

const setReviewsTab = async (tab: number) => {
  isLoading.value = true;
  includeLinked.value = tab;
  window.curentReviewsTab = tab;
  activePage.value = 1;
  await getModelReviews(props.model.id);
  isLoading.value = false;
};

onMounted(() => {
  if (!import.meta.env.SSR && window) {
    const emotion = window.localStorage.getItem('emotion');
    if (emotion) {
      emotionData.value = JSON.parse(emotion);
    }
  }
  if (!isBot && props.pageData?.reviewsData !== undefined) {
    otzyvy.value = props.pageData.reviewsData;
  } else {
    nextTick(() => {
      initModelReviews();
    });
  }
  if (window.curentReviewsTab) {
    includeLinked.value = window.curentReviewsTab;
  }
});
</script>
<style lang="scss" scoped src="./ModelReviewsScss.scss"></style>
